import { render, staticRenderFns } from "./platformHouseholdDetail.vue?vue&type=template&id=7606a428&scoped=true"
import script from "./platformHouseholdDetail.vue?vue&type=script&lang=js"
export * from "./platformHouseholdDetail.vue?vue&type=script&lang=js"
import style0 from "./platformHouseholdDetail.vue?vue&type=style&index=0&id=7606a428&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7606a428",
  null
  
)

export default component.exports